module.exports = __webpack_public_path__ + "assets/fall-icon.png?9a8f1bf662ec723ba34a582ba597f1fd";